// extracted by mini-css-extract-plugin
module.exports = {"switcher-container":"dashboard-switcher_switcher-container__3IyuI","card-container":"dashboard-switcher_card-container__3oMir"};